export default {
  name: 'welcome',
  path: '/home',
  component: () => import(/* webpackChunkName: "home" */ './index.vue')
}
